import { useEffect, useState } from "react"
import { useEsriModules } from "../common/useEsriModules"
import { SchemaField } from "./schema"
import {
  pushDefinitionChangesToEsri,
  esriToSchemaFields,
} from "./esriDefinitionHelpers"

/**
 * IMPORTANT TO NOTE!
 * Esri is strict with it's field defininitions, so there's
 * no way to store arbitrary meta against a field, i.e. the
 * field's variant (markdown, select, etc). Due to this,
 * I've decided to store the variant as part of the field
 * name. This can be stripped for management purposes. So a
 * required multi select field in the first place would look like:
 * Category:select:multiselect:true:0
 *
 * Also note: I bloody hate this solution. It's the easiest
 * I could come up with without mirroring the field schema
 * in another database which is unnecessary. If you have
 * problems with it please bring them up with me; we can
 * vent together.
 *
 * Because of this, I've done my absolute best to comment
 * everything as best as possible!!
 */

export const useLayerSchema = (layer: __esri.FeatureLayer | undefined) => {
  /** Store schema in state */
  const [schema, setSchema] = useState<SchemaField[] | undefined>()

  /** When there's a layer, grab the schema and set it here */
  useEffect(() => {
    if (layer) {
      setSchema(esriToSchemaFields(layer.fields))
    }
  }, [layer])

  /**
   * If the schema is set outside the hook, propoagate the
   * values to the attachment (and create one if there is
   * no attachment)
   */
  const [esriRequest] = useEsriModules<[typeof __esri.request]>([
    "esri/request",
  ])

  /**
   * Persists any changes made to the fields to ESRI
   * @param updatedFields full schema of updated fields from the form
   */
  const saveSchema = (updatedFields: SchemaField[]) =>
    pushDefinitionChangesToEsri(
      updatedFields,
      schema,
      layer,
      esriRequest
    ).then(() => setSchema(updatedFields))

  return { schema, saveSchema }
}
